module.exports = __webpack_public_path__ + "static/WEDDING E&M-352-7f64a380d0575367bbb9fa4f4d207128.jpg";